<svg
  width="56"
  height="56"
  viewBox="0 0 56 56"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <path
    opacity="0.85"
    d="M28.0005 1.64062V28L52.5005 23.5C58.5005 11 38.1359 1.64062 28.0005 1.64062Z"
    fill="#FE2C1F" />
  <path
    d="M28.0012 23.7969L26.8345 28.0008L28.0012 32.2048C30.323 32.2048 32.2051 30.3226 32.2051 28.0008C32.2051 25.679 30.323 23.7969 28.0012 23.7969Z"
    fill="#DAE7E8" />
  <path
    d="M23.7974 28.0008C23.7974 30.3226 25.6795 32.2048 28.0013 32.2048V23.7969C25.6795 23.7969 23.7974 25.679 23.7974 28.0008Z"
    fill="#DAE7E8" />
  <path
    d="M47.7995 8.20105C42.511 2.91255 35.4796 0 28.0005 0L27.4536 1.71358L28.0005 3.28125C34.6031 3.28125 40.8105 5.85244 45.4793 10.5212C49.7591 14.8011 52.2747 20.3744 52.6643 26.3594H46.6672V29.6406H52.6655C52.3112 35.0818 50.1977 40.1819 46.6006 44.2799L42.3599 40.0392L40.0397 42.3594L44.2804 46.6001C39.7727 50.5566 34.0532 52.7188 28.0005 52.7188V56C35.4796 56 42.5109 53.0875 47.7995 47.799C53.0879 42.5105 56.0005 35.4791 56.0005 28C56.0005 20.5209 53.0879 13.4895 47.7995 8.20105Z"
    fill="#DAE7E8" />
  <path
    d="M14.0121 52.3893C20.4652 56.17 28.0045 57.2114 35.2409 55.3218L35.3371 53.5256L34.4118 52.147C28.0234 53.8152 21.3678 52.8958 15.6709 49.5581C10.4486 46.4985 6.60641 41.7416 4.71728 36.0492L10.5198 34.534L9.6908 31.3592L3.88707 32.8747C2.85518 27.5205 3.61147 22.052 6.05647 17.178L7.71515 14.3469C11.0769 9.37984 16.0646 5.84276 21.9209 4.31348L21.0919 1.13869C13.8555 3.02836 7.7881 7.62296 4.00728 14.0761C0.226671 20.5292 -0.814822 28.0683 1.07484 35.3047C2.96451 42.5411 7.55912 48.6085 14.0121 52.3893Z"
    fill="#DAE7E8" />
  <path
    d="M8.20143 8.20105C2.91304 13.4895 0.000488281 20.5209 0.000488281 28V29.6429H3.33664V26.3594C3.69091 20.9181 5.80338 15.8181 9.40039 11.7201L13.6411 15.9608L15.9613 13.6406L11.7206 9.39991C16.2282 5.44337 21.9478 3.28125 28.0005 3.28125V0C20.5214 0 13.4899 2.91255 8.20143 8.20105Z"
    fill="#DAE7E8" />
</svg>
